/**
 * The default Shopify API version for this application across Admin and
 * Storefront. There is exactly one default, deliberately: scattered fallback
 * constants are how an app ends up reading a field the other half cannot
 * write. Callers may still opt into a separately vendored stable schema for a
 * specific compatibility need.
 *
 * Bumping it is a coordinated act, not a constant edit:
 *  1. vendor the new schemas into `configs/shopify/` (`<version>.graphql` and
 *     `storefront-<version>.graphql`),
 *  2. change this constant,
 *  3. re-run codegen for every deriving project (`moon run :generate-schema`).
 *
 * Versioned on their own axis, NOT from this constant: extension TOMLs,
 * checkout-ui, headless, `graphql.config.yml`, and `.dockerignore`'s allowlist.
 *
 * Step 2 used to come last, after separately repointing
 * `web/node-backend/codegen.ts` at the new files. It no longer does: codegen
 * derives both vendored paths from this constant, so there is nothing to
 * repoint, and the app cannot end up generating against one version while
 * claiming another. Step 3 is not optional bookkeeping — the Storefront SDL is
 * bundled as a runtime module and the rule-revalidation pass validates stored
 * queries against it, so skipping it leaves that pass checking the old schema
 * (it throws rather than under-check; see
 * `web/node-backend/src/lib/shopify-schema/storefront-schema.ts`).
 *
 * Explicit stable overrides and `unstable` remain opt-in versions (see
 * {@link SHOPIFY_GRAPHQL_API_VERSIONS}); neither changes this fallback.
 */
export const SHOPIFY_API_VERSION = "2026-07" as const;
export type ShopifyApiVersion = typeof SHOPIFY_API_VERSION;
